import { useTranslation } from 'react-i18next'
import ErrorPage from './ErrorPage'

export default function UnprocessableEntity() {
  const { t } = useTranslation()

  return (
    <ErrorPage
      status={422}
      title={t('errors.pages.422.title')}
      message={t('errors.pages.422.message')}
      showBackButton={true}
    />
  )
}
